import React from 'react';
import styled from 'styled-components';
import { Standard as StandardLink } from '@commoncomponents/frontend-components/dist/components/Link';
import { breakpoints } from '@commoncomponents/frontend-components/dist/styled';
import SearchBar from '../SearchBar';
import CheckBox from '../CheckBox';
import Warning from '../Warning';
const ModalHeaderWrapper = styled.div `
  padding: 4px 24px 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #29333d;
  flex: 0 0 auto;
  box-shadow: 0 16px 32px -16px rgba(41, 51, 61, 0.08);
  z-index: 1;

  .status-wrapper {
    padding: 6px 0 0;
  }

  & > .standard-link {
    margin: 10px 0 6px;
  }
  @media ${breakpoints.md} {
    padding: 4px 16px 16px;
  }
`;
const MainHeader = styled.span `
  font-size: 18px;
  display: flex;
  font-weight: 700;
`;
const SubHeader = styled.span `
  font-size: 14px;
  font-weight: 400;
`;
const CheckBoxWrapper = styled.div `
  display: flex;
`;
const SelectAllWrapper = styled.div `
  font-size: 14px;
  letter-spacing: 0.04px;
  display: flex;
  align-items: center;
`;
const OptionsWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ModalHeader = ({ translations, checked, numberOfSelectedUsers, handleSearchBarChange, onCheckBoxClick, isUpgradeWithPaymentView, onHaveActivationCodeButtonClick, isMobileView, shouldDisplayWarning, }) => {
    const HaveActivationCodeButton = () => (React.createElement(StandardLink, { size: "LARGE", onClick: onHaveActivationCodeButtonClick }, translations.haveActivationCodeButtonText));
    return (React.createElement(ModalHeaderWrapper, null,
        React.createElement(MainHeader, null, translations.mainHeader),
        React.createElement(SubHeader, null, translations.subHeader),
        isUpgradeWithPaymentView && isMobileView && React.createElement(HaveActivationCodeButton, null),
        React.createElement(SearchBar, { placeholder: translations.searchBar.placeholder, onChange: handleSearchBarChange }),
        isUpgradeWithPaymentView && (React.createElement(OptionsWrapper, null,
            React.createElement(CheckBoxWrapper, null,
                React.createElement(CheckBox, { onClick: onCheckBoxClick, checked: checked }),
                React.createElement(SelectAllWrapper, null,
                    translations.selectAllText,
                    "\u00A0(",
                    numberOfSelectedUsers,
                    ")")),
            !isMobileView && React.createElement(HaveActivationCodeButton, null))),
        shouldDisplayWarning && (React.createElement(Warning, { message: translations.warningMessage }))));
};
export default ModalHeader;
